import React, { useState } from 'react'
import { flowRight, get } from 'lodash'
import { withRouter } from 'react-router-dom'
import { withTranslationCustom } from 'lib/i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getPrimaryLocation, writeToPrimaryLocationState } from 'lib/location'

import ControlledModal from 'components/Modal/ControlledModal'
import EventFormLogic from 'components/Events/EventForm/EventFormLogic'
import FileUploadLogic from 'components/Upload/FileUploadLogic'
import LoadingIndicator from 'components/LoadingIndicator'
import ErrorComponent from 'components/Errors/ErrorComponent'

const EventModal = ({ t, match, location, history }) => {
    const { formMode, vehicleId, eventType, eventId } = match.params

    const primaryLocation = getPrimaryLocation(location)
    const [file] = useState(get(primaryLocation, 'state.file'))

    const renderForm = (modalProps, initAttachment = null) => (
        <EventFormLogic
            initEvent={{
                type: eventType ? eventType.toUpperCase() : null,
                id: eventId,
                attachments: initAttachment ? [initAttachment] : null
            }}
            vehicleId={vehicleId}
            renderButtonsPortalTarget={modalProps.mobileButtonsDOMElement}
            onCancel={modalProps.closeModal}
            formMode={formMode.toUpperCase()}
        />
    )

    const renderFormWithFileUpload = (modalProps) => (
        <FileUploadLogic
            initState={{ loading: true }}
            onMount={(fileUploadLogic) => {
                // clear the file from state when starting to upload to avoid reupload on page refresh
                writeToPrimaryLocationState(history, { file: null })
                return fileUploadLogic.uploadVehicleAttachment(vehicleId, file)
            }}
        >
            {({ loading, error, data }) => {
                if (error) return <ErrorComponent />
                if (loading) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
                            <LoadingIndicator />
                            <div>{t('events:attachments.uploadingFile')}</div>
                        </div>
                    )
                }

                const attachmentFile = data.uploadVehicleAttachment

                return renderForm(modalProps, attachmentFile)
            }}
        </FileUploadLogic>
    )

    return (
        <ControlledModal
            routedModal
            name="event-modal"
            context="eventModal"
            requireUserInput={false}
            disableBackdropCloseClick={true}
        >
            {(modalProps) => !file ? renderForm(modalProps) : renderFormWithFileUpload(modalProps)}
        </ControlledModal>
    )
}

export default flowRight(
    withErrorBoundaryNoRender,
    withRouter,
    withTranslationCustom('events'),
)(EventModal)
